import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Constants from '../constants';
import Api from '../utils/Api';
import ReCAPTCHA from 'react-google-recaptcha';

import Background from '../components/Background';
import Process2FA from '../process/Process2FA';
import Logo from '../images/logo.svg'

const PROCESS_STATES = [
    'REGISTER',
    'ENABLE-2FA',
    'VALIDATE-2FA',
    'COMPLETED'
]

const Register = () => {
    const [data, setData] = useState({
        email: '',
        password: '',
        token: '',
    })

    const [account, setAccount] = useState(false)
    const [processState, setProcessState] = useState(PROCESS_STATES[0])
    const [registerOn, setRegisterOn] = useState(false)
    const [termAndCondintions, setTermsAndConditions] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [validations, setValidations] = useState({
        specialCharacter: false,
        capitalLetter: false,
        lowerCase: false,
        minCharacters: false,
        number: false
    })

    useEffect(() => {
        passwordValidations()
        let result = Object.values(validations).every(value => value === true);
        setRegisterOn(result && termAndCondintions)
    }, [data.password, termAndCondintions])

    const createAccount = () => {
        return Api.fetch(Constants.BACKEND_APIS.register(), 'POST', data).then(resp => {
            setAccount(resp)
            setProcessState(PROCESS_STATES[1])
        }).catch(error => {
            console.log('error register')
        })
    }

    const passwordValidations = () => {
        const validation = {
            specialCharacter: /[!@#$%^&*()_+{}:;<>,.?~/-]/.test(data.password),
            capitalLetter: /[A-Z]/.test(data.password),
            lowerCase: /[a-z]/.test(data.password),
            minCharacters: data.password.length >= 8,
            number: /\d/.test(data.password)
        }
        setValidations(validation)
    }

    const handleChange = (e) => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value || '';
        const name = target.name;
        const newData = { ...data };
        newData[name] = value;
        setData(newData);
    }

    function onChangeCaptcha(value) {
        const newData = { ...data };
        newData['token'] = value;
        setData(newData);
    }

    const ValidationItem = ({ passed, label }) => (
        <div className='flex items-center gap-2 mb-2'>
            <div className={`w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200 ${passed ? 'bg-green-500/20 border border-green-500/40' : 'bg-white/5 border border-white/10'}`}>
                {passed && <i className='bx bx-check text-xs text-green-400'></i>}
            </div>
            <span className={`text-xs transition-colors duration-200 ${passed ? 'text-green-400' : 'text-gray-500'}`}>{label}</span>
        </div>
    )

    return (
        <>
            <Background />
            <Process2FA
                account={account}
                processState={processState}
                setProcessState={setProcessState}
                redirectURL={'/login'}
                confirm
            />

            <div className='grid grid-cols-1 lg:grid-cols-12 min-h-screen w-full'>
                {/* Left sidebar */}
                <div className='hidden lg:flex lg:col-span-3 flex-col justify-between p-10 border-r' style={{background: 'rgba(255,255,255,0.02)', borderColor: 'rgba(255,255,255,0.06)'}}>
                    <div>
                        <a href="/" className='flex items-center gap-2 mb-16'>
                            <img src={Logo} className="h-7" alt="Logo" />
                            <span className='text-white font-semibold text-base tracking-tight'>Digipayments</span>
                        </a>
                        <h2 className='text-white text-2xl font-title leading-snug mb-4'>Tu billetera digital, sin complicaciones.</h2>
                        <p className='text-gray-500 text-sm leading-relaxed'>Realizá transferencias a cualquier CBU o CVU de forma rápida, segura y disponible las 24hs.</p>
                    </div>
                    <div>
                        <div className='flex items-center gap-3 p-4 rounded-xl border' style={{background: 'rgba(38,122,182,0.06)', borderColor: 'rgba(38,122,182,0.15)'}}>
                            <i className='bx bx-shield-quarter text-2xl color-dark-sky-blue'></i>
                            <div>
                                <p className='text-white text-xs font-semibold mb-0.5'>Protección total</p>
                                <p className='text-gray-500 text-xs'>Verificación en dos pasos en cada acceso.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Form area */}
                <div className='lg:col-span-9 flex items-center justify-center px-6 py-12'>
                    <div className='w-full max-w-md'>
                        <div className='mb-8'>
                            <div className='section-label mb-2'>Nuevo usuario</div>
                            <h1 className='text-white text-2xl font-semibold tracking-tight'>Es hora de empezar</h1>
                            <p className='text-gray-500 text-sm mt-1'>Con unos pocos datos podés cambiar el futuro de tus finanzas.</p>
                        </div>

                        {/* Email */}
                        <div className='mb-4'>
                            <label className='block text-xs font-medium text-gray-400 mb-1.5'>Correo electrónico</label>
                            <input
                                value={data?.email}
                                onChange={handleChange}
                                name="email"
                                type="email"
                                id="email"
                                className="w-full px-3 py-2.5 text-sm text-white rounded-lg border focus:outline-none modal-input"
                                style={{background: '#252525', borderColor: 'rgba(255,255,255,0.1)'}}
                                placeholder="correo@ejemplo.com"
                                required
                            />
                        </div>

                        {/* Password */}
                        <div className='mb-5'>
                            <label className='block text-xs font-medium text-gray-400 mb-1.5'>Contraseña</label>
                            <div className='relative'>
                                <input
                                    onChange={handleChange}
                                    value={data?.password}
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    className="w-full px-3 py-2.5 pr-10 text-sm text-white rounded-lg border focus:outline-none modal-input"
                                    style={{background: '#252525', borderColor: 'rgba(255,255,255,0.1)'}}
                                    placeholder="Creá tu contraseña"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 transition-colors duration-200'
                                >
                                    <i className={`bx ${showPassword ? 'bx-hide' : 'bx-show'} text-lg`}></i>
                                </button>
                            </div>
                        </div>

                        {/* Password validations */}
                        <div className='grid grid-cols-2 gap-x-6 mb-5 px-1'>
                            <div>
                                <ValidationItem passed={validations.specialCharacter} label="Carácter especial" />
                                <ValidationItem passed={validations.capitalLetter} label="Mayúscula" />
                                <ValidationItem passed={validations.lowerCase} label="Minúscula" />
                            </div>
                            <div>
                                <ValidationItem passed={validations.minCharacters} label="Mínimo 8 caracteres" />
                                <ValidationItem passed={validations.number} label="Número" />
                            </div>
                        </div>

                        {/* Terms */}
                        <div className='flex items-start gap-2.5 mb-6'>
                            <input
                                id="link-checkbox"
                                type="checkbox"
                                onChange={() => setTermsAndConditions(!termAndCondintions)}
                                value={termAndCondintions}
                                className="cursor-pointer w-4 h-4 mt-0.5 rounded flex-shrink-0"
                                style={{accentColor: '#267ab6'}}
                            />
                            <label htmlFor="link-checkbox" className="text-xs text-gray-400 leading-relaxed">
                                Acepto los{' '}
                                <a target='_blank' href="/terms-and-conditions" className="text-blue-400 hover:text-blue-300 transition-colors duration-200">Términos y condiciones</a>
                                {' '}y la{' '}
                                <a target='_blank' href="/privacy-policy" className="text-blue-400 hover:text-blue-300 transition-colors duration-200">Política de Privacidad</a>.
                            </label>
                        </div>

                        {/* reCAPTCHA */}
                        {Constants.CAPTCHA_SITE_KEY && (
                            <div className='mb-6'>
                                <ReCAPTCHA
                                    sitekey={Constants.CAPTCHA_SITE_KEY}
                                    onChange={onChangeCaptcha}
                                    theme="dark"
                                />
                            </div>
                        )}

                        {/* Submit */}
                        <button
                            disabled={!registerOn}
                            onClick={createAccount}
                            className="w-full py-2.5 px-4 text-sm font-semibold rounded-full button-action"
                            style={!registerOn ? {opacity: 0.5, cursor: 'not-allowed'} : {}}
                        >
                            Crear Cuenta
                        </button>

                        <p className='text-center text-sm text-gray-500 mt-5'>
                            ¿Ya tenés cuenta?{' '}
                            <Link to="/login" className='text-blue-400 hover:text-blue-300 transition-colors duration-200'>Iniciar sesión</Link>
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Register;
